import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const SignupPage = lazy(() => import('../pages/signup/page'));
const PrivacyPolicyPage = lazy(() => import('../pages/privacy-policy/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const ApplyPage = lazy(() => import('../pages/apply/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />
  },
  {
    path: "/login",
    element: <LoginPage />
  },
  {
    path: "/signup", 
    element: <SignupPage />
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicyPage />
  },
  {
    path: "/admin",
    element: <AdminPage />
  },
  {
  path: "/apply",
  element: <ApplyPage />
  },
  {
    path: "*",
    element: <NotFoundPage />
  }
];

export default routes;
